const URI = {
    HOME: "/",
    LOGIN: "/login",
    SIGNUP: "/signup",
    QUIZ: "/quiz",
    PREFERENCES: "/preferences",
    SCOREBOARD: "/scoreboard",
    REVIEW: "/review",
    CONTACT:"/contact",
    TEST: "/test",
}

export default URI;